import { useEffect, useState } from "react";
import { ShieldCheck, ShieldAlert, CheckCircle2, XCircle } from "lucide-react";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api } from "@/lib/api";

function BlockedResult({ r }) {
  return (
    <div className="rounded-2xl border border-red-500/50 bg-red-500/10 p-4" data-testid="screening-result-blocked">
      <p className="flex items-center gap-2 font-bold"><ShieldAlert size={18} className="text-red-400" /> Publicação bloqueada pelo Guarda-Costas IA</p>
      <p className="mt-1 text-sm text-red-200" data-testid="screening-block-message">{r.msg || "Foram detectados termos impróprios. Remova-os da legenda, do texto na tela ou da fala para poder publicar."}</p>
      {r.checks?.length > 0 && (
        <ul className="mt-2 space-y-1 text-sm">
          {r.checks.map((c) => (
            <li key={c.label} className="flex items-start gap-2">{c.ok ? <CheckCircle2 size={15} className="mt-0.5 text-emerald-400" /> : <XCircle size={15} className="mt-0.5 text-red-400" />}
              <span>{c.label}{c.reason ? <span className="text-muted-foreground"> — {c.reason}</span> : ""}</span></li>
          ))}
        </ul>
      )}
    </div>
  );
}

export function PublishPanel({ form, setForm, onPublish, blocked }) {
  const [dests, setDests] = useState([]);
  useEffect(() => { api.get("/shorts/destinations").then((r) => setDests(r.data)); }, []);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div className="space-y-4" data-testid="details-step">
      <div className="space-y-1.5">
        <Label>Legenda</Label>
        <Textarea value={form.caption} onChange={set("caption")} maxLength={220} placeholder="Conte sobre a publicação… use #hashtags" data-testid="short-caption-input" />
      </div>
      <div className="space-y-1.5">
        <Label>Publicar em</Label>
        <Select value={form.destination_id || "community"} onValueChange={(v) => setForm({ ...form, destination_id: v === "community" ? null : v })}>
          <SelectTrigger data-testid="short-destination-select"><SelectValue /></SelectTrigger>
          <SelectContent>{dests.map((d) => <SelectItem key={d.id || "community"} value={d.id || "community"}>{d.name}</SelectItem>)}</SelectContent>
        </Select>
      </div>
      {blocked ? <BlockedResult r={blocked} /> : (
        <p className="flex items-start gap-2 text-xs text-muted-foreground" data-testid="publish-hint">
          <ShieldCheck size={15} className="mt-0.5 shrink-0 text-emerald-400" /> Ao publicar, a mídia é enviada para a nuvem e o Guarda-Costas IA analisa a legenda, os textos e o áudio (Whisper) antes de entrar no feed.
        </p>
      )}
      <Button onClick={onPublish} disabled={!form.caption.trim()} className="h-11 w-full rounded-full font-bold" data-testid="short-publish-button">Publicar</Button>
    </div>
  );
}
